export enum DeviceType {
  Unknown = 'Unknown',
  ArgusUnit = 'ArgusUnit',
  // Used only for IP Units imported from Viewpoint
  IPunitV2 = 'IPunitV2',
  DIP0101 = 'DIP0101',
  Sec0104 = 'Sec0104',
  Sec0105 = 'Sec0105',
  S0303 = 'S0303',
  GenericSIP = 'GenericSIP',
  ExternalURL = 'ExternalURL',
  CameraGeneric = 'CameraGeneric',
  CameraAxis = 'CameraAxis',
  CameraMobotix = 'CameraMobotix',
  DoorbellIntercom = 'DoorbellIntercom',
  DesoField = 'DesoField',
  EspaInBrand = 'EspaInBrand',
  EspaInDwaalDetectie = 'EspaInDwaalDetectie',
  G1 = 'G1',
  G2 = 'G2',
  DesoClient = 'DesoClient',
  Services = 'Services',
  Universal = 'Universal',
  UniversalCamera = 'UniversalCamera',
  UniversalAudio = 'UniversalAudio',
  UniversalAlarmTransmitter = 'UniversalAlarmTransmitter',
  UniversalIntercom = 'UniversalIntercom',
  NFC = 'NFC',
  ESPA = 'ESPA',
  BLEBeacon = 'BLEBeacon',
  S0304 = 'S0304',
  Sec0106 = 'Sec0106',
  IPUnit = 'IPUnit',
  G2Transmitter = 'G2Transmitter',
  G2SmokeAlarm = 'G2SmokeAlarm',
  G2MotionDetector = 'G2MotionDetector',
  G2DoorContact = 'G2DoorContact',
  G2TableAlarm = 'G2TableAlarm',
  G2Contact = 'G2Contact',
  G2ToiletAlarm = 'G2ToiletAlarm',
  G2General = 'G2General',
  DesoResidentTransmitter = 'DesoResidentTransmitter',
  DesoSupervisorTransmitter = 'DesoSupervisorTransmitter',
  DesoDetectionLoop = 'DesoDetectionLoop',
  DomipOutput = 'DomipOutput',
  DoorAlarm = 'DoorAlarm',
  DomipInput = 'DomipInput',
}

export const G2DeviceTypes: DeviceType[] = [
  DeviceType.G2Transmitter,
  DeviceType.G2SmokeAlarm,
  DeviceType.G2MotionDetector,
  DeviceType.G2DoorContact,
  DeviceType.G2TableAlarm,
  DeviceType.G2Contact,
  DeviceType.G2ToiletAlarm,
] as const;

export const isG2Device = (deviceType: DeviceType): boolean => {
  return G2DeviceTypes.includes(deviceType);
};

export const UniversalDeviceTypes: DeviceType[] = [
  DeviceType.Universal,
  DeviceType.UniversalCamera,
  DeviceType.UniversalAudio,
  DeviceType.UniversalAlarmTransmitter,
  DeviceType.UniversalIntercom,
] as const;

export const isUniversalDevice = (deviceType: DeviceType): boolean => {
  return UniversalDeviceTypes.includes(deviceType);
};
